var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadedFile = function SvgUploadedFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004876",
    d: "M30 11.2 20.8 2h-14C4.16 2 2 4.16 2 6.8v26.4C2 35.84 4.16 38 6.8 38h18.4c2.64 0 4.8-2.16 4.8-4.8zm-3-.2h-1.8c-2.08 0-3.8-1.72-3.8-3.8l-.08-1.88zm1 22.2c0 1.56-1.24 2.8-2.8 2.8H6.8C5.24 36 4 34.76 4 33.2V6.8C4 5.24 5.24 4 6.8 4h12.44l.16 3.24c0 3.2 2.6 5.76 5.8 5.76H28z"
  })));
};
export default SvgUploadedFile;